import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "children"];
import * as React from 'react';
import { styled } from '@mui/system';
import { getDataGridUtilityClass } from '@mui/x-data-grid-pro';
import { vars } from '@mui/x-data-grid-pro/internals';
import { unstable_composeClasses as composeClasses } from '@mui/utils';
import clsx from 'clsx';
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { jsx as _jsx } from "react/jsx-runtime";
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['sidebarHeader']
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const SidebarHeaderRoot = styled('div', {
  name: 'MuiDataGrid',
  slot: 'SidebarHeader'
})({
  position: 'sticky',
  top: 0,
  borderBottom: `1px solid ${vars.colors.border.base}`
});
function SidebarHeader(props) {
  const {
      className,
      children
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses(rootProps);
  return /*#__PURE__*/_jsx(SidebarHeaderRoot, _extends({
    className: clsx(className, classes.root),
    ownerState: rootProps
  }, other, {
    children: children
  }));
}
export { SidebarHeader };